<template>
        <header id="masthead" class="header top-menu" role="menu">
            <nav role="navigation" class="navbar navbar-fixed-top navbar-abft-top">
                <div class="container">
                    <!--Menu Navigation-->
                    <a href="" class="header-icon icon-on-xs-screen" id="header-icon"></a>
                    <a href="http://www.abft.be" class="header-logo logos-sprite logos-logo_ABFT_mini"></a>
                    <!--Menu Normal-->
                    <ul class="navbar-nav-perso navbar-mobile" id="nav">
                        <!--<li class="menu-faq"><a href="">FAQ</a></li><li class="dividerPerso"></li>-->
                        <li class="hidden-sm hidden-xs menu-contact">
                            <a href="https://www.abft.be/calendrier-abft/">CALENDRIER</a>
                        </li>
                        <li class="dividerPerso"></li>
                        <li class="hidden-sm hidden-xs menu-contact">
                            <a href="https://www.abft.be/secretariat/">CONTACT</a>
                        </li>
                        <li class="dividerPerso"></li>
                        <!--<li class="menu-connect"><a href="">SE CONNECTER</a></li><li class="dividerPerso"></li>-->

                        <!--                                    <li class="menu-compte dropdown ">
                                                                <a class="dropdown-toggle" data-toggle="dropdown" href="#">VOTRE COMPTE<span class="caret"></span></a>
                                                                <ul role="menu" class="dropdown-menu">
                                                                    <li><a href="#">Action</a></li>
                                                                    <li><a href="#">Another action</a></li>
                                                                    <li><a href="#">Something else here</a></li>
                                                                    <li class="divider"></li>
                                                                    <li class="dropdown-header">Nav header</li>
                                                                    <li><a href="#">Separated link</a></li>
                                                                    <li><a href="#">One more separated link</a></li>
                                                                </ul>
                                                            </li>-->
                        <li class="hidden-sm hidden-xs  important-menu ">
                            <a href="https://www.abft.be/services/#ouverture_club">
                                OUVREZ VOTRE CLUB
                            </a>
                        </li>
                        <li class="dividerPerso"></li>
                        <li class="hidden-sm hidden-xs  important-menu">
                            <a href="http://www.abft.be/calendar/examen-dan-poom-keup-2/">
                                EXAMEN KEUP/POOM/DAN
                            </a>
                        </li>
                    </ul>

                </div>
            </nav>
        </header>
</template>

<script type="text/babel">
    import Auth from '@/auth'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        data() {
            return {
            }
        },
        components: {
        },
        computed: {
            ...mapGetters({
            })
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/Header.vue